import styled from 'styled-components';

export const SearchContainer = styled.div`
  width: 360px;
`;
